module.exports = __webpack_public_path__ + "img/Ib.fa5ebb01.png";